import { useQuery } from '@tanstack/react-query';
import { Building2, Boxes, Users as UsersIcon } from 'lucide-react';
import { api } from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';

export function Dashboard() {
  const orgs = useQuery({ queryKey: ['organizations'], queryFn: () => api.listOrganizations() });
  const users = useQuery({ queryKey: ['users'], queryFn: () => api.listUsers() });
  const apps = useQuery({ queryKey: ['applications'], queryFn: () => api.listApplications() });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">Snapshot of the X5 customer footprint.</p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <StatCard
          title="Organizations"
          value={orgs.data?.items.length}
          loading={orgs.isLoading}
          icon={<Building2 className="h-4 w-4 text-muted-foreground" />}
          description="Total customer organizations"
        />
        <StatCard
          title="Users"
          value={users.data?.items.length}
          loading={users.isLoading}
          icon={<UsersIcon className="h-4 w-4 text-muted-foreground" />}
          description="Total end-user accounts"
        />
        <StatCard
          title="Applications"
          value={apps.data?.items.length}
          loading={apps.isLoading}
          icon={<Boxes className="h-4 w-4 text-muted-foreground" />}
          description="Provisioned X5 server applications"
        />
      </div>
    </div>
  );
}

function StatCard({
  title,
  value,
  loading,
  icon,
  description,
}: {
  title: string;
  value: number | undefined;
  loading: boolean;
  icon: React.ReactNode;
  description?: string;
}) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {icon}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{loading ? '…' : (value ?? '—')}</div>
        {description && <p className="text-xs text-muted-foreground mt-1">{description}</p>}
      </CardContent>
    </Card>
  );
}
